import { useHistoricalPrescriptions } from '../hooks/useHistoricalPrescriptions';
import { HistoricalPrescriptions } from './HistoricalPrescriptions';
import { Skeleton } from '@/components/ui/skeleton';

interface HistoricalPrescriptionsSectionProps {
  patientId: string;
  onPrescriptionStatusChange: (prescription: { id: string; medication: string; active: boolean }) => void;
}

export function HistoricalPrescriptionsSection({ 
  patientId,
  onPrescriptionStatusChange 
}: HistoricalPrescriptionsSectionProps) {
  const {
    prescriptions,
    isLoading,
    error,
    updatePrescriptionStatus,
  } = useHistoricalPrescriptions(patientId);

  if (isLoading) {
    return <Skeleton className="w-full h-48" />;
  }

  if (error) {
    return null; // Hide section on error to avoid disrupting the UI
  }

  return (
    <HistoricalPrescriptions
      prescriptions={prescriptions}
      onUpdatePrescription={(prescription) => {
        updatePrescriptionStatus(prescription.id, prescription.active);
        onPrescriptionStatusChange(prescription);
      }}
    />
  );
}
